export default "__VITE_ASSET__BCuuE3jt__"